import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import { sync } from "vuex-router-sync";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { i18n } from "./plugins/i18n";
import swal from "sweetalert";
import VueYouTubeEmbed from "vue-youtube-embed";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
import VCalendar from "v-calendar";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import IdleVue from "idle-vue";

Vue.use(VueTelInputVuetify, {
  vuetify
});

Vue.use(VCalendar, {
  componentPrefix: "vc"
});
Vue.use(VueYouTubeEmbed);

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

Vue.config.productionTip = false;
sync(store, router);

import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-2";

Vue.use(TawkMessengerVue, {
  propertyId: "610031c2d6e7610a49ad4078",
  widgetId: "1fbkc4ojk"
});

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 14400000
});

new Vue({
  router,
  store,
  axios,
  i18n,
  vuetify,
  swal,
  render: h => h(App)
}).$mount("#app");
